import { PaletteMode } from '@mui/material';

export const light = {
  alternate: {
    main: '#f4f7fb',
    dark: '#e6ebf2',
  },
  cardShadow: '0 12px 32px rgba(22, 54, 93, 0.07)',
  mode: 'light' as PaletteMode,
  primary: {
    main: '#1475d1',
    light: '#3a8ee0',
    dark: '#0b5cb5',
    contrastText: '#fff',
  },
  secondary: {
    light: '#ffe566',
    main: '#ffca05',
    dark: '#e6b600',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#17263d',
    secondary: '#78869a',
  },
  divider: '#e6ebf2',
  background: {
    paper: '#ffffff',
    default: '#f4f7fb',
    level2: '#f4f7fb',
    level1: '#ffffff',
  },
  // Docket spending category colours — use these directly for category-specific UI
  spending: {
    needs: '#159b72',
    wants: '#EC4899',
    savings: '#3B82F6',
    overTarget: '#ff454d',
    warning: '#ff8b32',
  },
  // Docket brand colours
  brand: {
    navy: '#102542',
    blue: '#1475d1',
    yellow: '#ffca05',
    green: '#159b72',
    red: '#ff454d',
    orange: '#ff8b32',
    muted: '#78869a',
    line: '#e6ebf2',
    wash: '#f4f7fb',
  },
};

export const dark = {
  alternate: {
    main: '#1a2138',
    dark: '#151a30',
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark' as PaletteMode,
  primary: {
    main: '#1976d2',
    light: '#2196f3',
    dark: '#0d47a1',
    contrastText: '#fff',
  },
  secondary: {
    light: '#FFEA41',
    main: '#FFE102',
    dark: '#DBBE01',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#222B45',
    default: '#222B45',
    level2: '#333',
    level1: '#2D3748',
  },
};
